import AppBaseEntity from '@/storage/modules/AppBaseEntity'
import GroupTagFilterEntity from './modules/GroupTagFilterEntity'
import HotelCEMCommonFilterEntity from './modules/hotelcem/HotelCEMCommonFilterEntity'
/**
 * Storage Keys Config
 */
export default Object.freeze({
  // 应用基础信息
  VOCUST_APP_BASE_ID: {
    Key: 'VOCUST_APP_BASE_ID',
    EntityClass: AppBaseEntity,
  },
  // 酒店CEM公共查询参数
  VOCUST_HOTEL_CEM_FILTER_KEY: {
    Key: 'VOCUST_HOTEL_CEM_FILTER_KEY',
    EntityClass: HotelCEMCommonFilterEntity,
  },
  // 酒店CEM默认酒店
  VOCUST_HOTEL_CEM_DEFAULT: {
    Key: 'VOCUST_HOTEL_CEM_DEFAULT',
    EntityClass: HotelCEMCommonFilterEntity,
  },
  // 集团tag过滤条件缓存
  VOCUST_GROUP_TAG_FILTER_KEY: {
    Key: 'VOCUST_GROUP_TAG_FILTER_KEY',
    EntityClass: GroupTagFilterEntity,
  },
})
